import { render } from "./paymentView.vue?vue&type=template&id=4f2a0d56&scoped=true&ts=true"
import script from "./paymentView.vue?vue&type=script&lang=ts"
export * from "./paymentView.vue?vue&type=script&lang=ts"

import "./paymentView.vue?vue&type=style&index=0&id=4f2a0d56&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2a0d56"]])

export default __exports__